import { SearchResultType, fetchSearch } from "@api/search";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

export const QUERY_KEY_SEARCH_SUPPLIERS = ['suppliersSearch']

const useSupplierSearchQuery = (
    searchTerm: string,
    categorySlug: string,
    includeInactiveSuppliers: boolean = false,
    options: Omit<UseQueryOptions<any, any>, 'queryKey' | 'queryFn'> = {}
) => {
    const { isLoading, data } = useQuery<SearchResultType[]>({
        queryKey: [...QUERY_KEY_SEARCH_SUPPLIERS, searchTerm, categorySlug, includeInactiveSuppliers],
        queryFn: ({ queryKey}) => {
            const [_, searchTerm, categorySlug, includeInactiveSuppliers] = queryKey as [string, string, string, boolean];
            return fetchSearch(searchTerm, categorySlug, includeInactiveSuppliers)
        },
        enabled: searchTerm.length > 2,
        refetchOnMount: false,
        staleTime: 1000 * 60 * 60 * 24, // 24 hours
        ...options,
    });
    return { isLoading, data };
}

export default useSupplierSearchQuery;